import * as types from './mutation-types'
import Vue from 'vue'

const state = {
  project_name: '',
  valid_file_types: ['image/svg+xml'],
  assets_library: {},
  upload_files_pending: [],
  lastNodeIdAdded: '',
  local_save_working: true,
  upload_warnings: [],
  operation_list: [],
  redooperation_list: []
}

const mutations = {
  [types.STATE_NEW] (state) {
    var data = {
      project_name: '',
      valid_file_types: ['image/svg+xml'],
      assets_library: {},
      upload_files_pending: [],
      upload_warnings: []
    }
    for (var key in data) {
      state[key] = data[key]
    }
  },
  [types.STATE_LOAD] (state, data) {
    if (data === undefined) {
      // load from cache (local storage)
      // window.localStorage.key(state.storage_id)
      data = JSON.parse(window.localStorage.getItem('project'))
      data['operation_list'] = JSON.parse(window.sessionStorage.getItem('operation_list')) || []
      data['redooperation_list'] = JSON.parse(window.sessionStorage.getItem('redooperation_list')) || []
    }
    for (var key in data) {
      state[key] = data[key]
    }

    state.upload_warnings = []
  },

  [types.STATE_SAVE] (state) {
    // reset the pending files
    state.upload_files_pending = []
    try {
      const {operation_list, redooperation_list, ...localStorageProperties} = state

      // store operation & redo list in session storage and remove from state when storing in localstorage
      window.sessionStorage.setItem('operation_list', JSON.stringify(state.operation_list))
      window.sessionStorage.setItem('redooperation_list', JSON.stringify(state.redooperation_list))
      window.localStorage.setItem('project', JSON.stringify(localStorageProperties))
      state.local_save_working = true
    } catch (e) {
      // console.log('err', e)
      state.local_save_working = false
    }
  },

  [types.PROJECT_NAME_SET] (state, newName) {
    state.project_name = newName
  },

  [types.ASSET_LIBRARY_ADD] (state, pendingFile) {
    // get unique id
    var id = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    while (state.assets_library[id] !== undefined) {
      id = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }
    pendingFile.id = id

    // get file content and inject id

    // pendingFile.svgString = pendingFile.svgString.substr(0, 5) + pendingFile.svgString.substr(5)

    const xml = new window.DOMParser().parseFromString(pendingFile.svgString, 'text/xml')

    xml.children[0].id = id

    if (!xml.children[0].width.baseVal.value || !xml.children[0].height.baseVal.value) {
      // window.alert()
      // let warn = []
      console.log('ALERT ALERT')
      // warn.push('Warning: An uploaded SVG lacks height or width. This is necessary for the HTML Engine')
      // state.upload_warnings.push('Warning: An uploaded SVG lacks height or width. This is necessary for the HTML Engine')
      // Vue.set(state.upload_warnings, state.upload_warnings.length, warn)
      state.upload_warnings.push('Warning: An uploaded SVG lacks height or width. This is necessary for the HTML Engine')
    }

    const serializer = new window.XMLSerializer()
    pendingFile.svgString = serializer.serializeToString(xml)

    window.xml = pendingFile.svgString

    pendingFile.perspectiveDistortion = 1
    pendingFile.nodes = {}
    pendingFile.nodeConnectors = {}
    Vue.set(state.assets_library, id, pendingFile)
  },

  [types.PENDING_FILE_ADD] (state, pendingFile) {
    Vue.set(state.upload_files_pending, state.upload_files_pending.length, pendingFile)
  },

  [types.PENDING_FILE_REMOVE] (state, pendingFile) {
    state.upload_files_pending = state.upload_files_pending.filter(function (f) {
      return f !== pendingFile
    })
  },

  [types.PENDING_FILE_UPDATE] (state, obj) {
    obj.pendingFile[obj.key] = obj.value
    Vue.set(obj.pendingFile, obj.key, obj.value)
  },

  [types.ASSET_NODE_ADD] (state, obj) {
    if (state.assets_library[obj.assetId].nodes === undefined) {
      state.assets_library[obj.assetId].nodes = {}
    }
    // generate random id and assign to node if id is undefined
    if (obj.node.id === undefined) {
      var id = Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1)
      while (state.assets_library[obj.assetId].nodes[id] !== undefined) {
        id = Math.floor((1 + Math.random()) * 0x1000000).toString(16).substring(1)
      }
      obj.node.id = id
      state.lastNodeIdAdded = id
    }

    Vue.set(state.assets_library[obj.assetId].nodes, obj.node.id, obj.node)
  },

  [types.ASSET_NODE_ROUND] (state, obj) {
    var amt = Math.pow(10, obj.dec)
    if (state.assets_library[obj.assetId].nodes) {
      for (var nodeId in state.assets_library[obj.assetId].nodes) {
        var node = state.assets_library[obj.assetId].nodes[nodeId]
        node.x = Math.round(node.x * amt) / amt
        node.y = Math.round(node.y * amt) / amt
      }
    }
  },

  [types.ASSET_PERSPECTIVEDISTORTION_UPDATE] (state, obj) {
    if (state.assets_library[obj.assetId]) {
      Vue.set(state.assets_library[obj.assetId], 'perspectiveDistortion', obj.value)
    }
  },

  [types.ASSET_NODE_UPDATE] (state, obj) {
    if (state.assets_library[obj.assetId] && state.assets_library[obj.assetId].nodes && state.assets_library[obj.assetId].nodes[obj.nodeId]) {
      Vue.set(state.assets_library[obj.assetId].nodes[obj.nodeId], obj.key, obj.value)
    }
  },

  [types.ASSET_NODE_REMOVE] (state, obj) {
    if (state.assets_library[obj.assetId] && state.assets_library[obj.assetId].nodes && state.assets_library[obj.assetId].nodes[obj.nodeId]) {
      Vue.delete(state.assets_library[obj.assetId].nodes, obj.nodeId)
      console.warn('TODO: remove connections too when deleting node')
    }
  },

  [types.ASSET_NODE_REMOVE_FIELD] (state, obj) {
    if (state.assets_library[obj.assetId] && state.assets_library[obj.assetId].nodes && state.assets_library[obj.assetId].nodes[obj.nodeId]) {
      Vue.delete(state.assets_library[obj.assetId].nodes[obj.nodeId], obj.key)
    }
  },

  [types.ASSET_NODE_CONNECTOR_REMOVE_FIELD] (state, obj) {
    if (state.assets_library[obj.assetId] && state.assets_library[obj.assetId].nodeConnectors && state.assets_library[obj.assetId].nodeConnectors[obj.connectionId]) {
      Vue.delete(state.assets_library[obj.assetId].nodeConnectors[obj.connectionId], obj.key)
    }
  },

  [types.ASSET_NODE_CONNECTOR_ADD] (state, obj) {
    var nodeConnectors = obj.asset.nodeConnectors
    if (nodeConnectors === undefined) {
      obj.asset.nodeConnectors = {}
    }
    var id = [obj.connector.node0, obj.connector.node1].sort() + ''
    Vue.set(obj.asset.nodeConnectors, id, obj.connector)
  },

  [types.ASSET_NODE_CONNECTOR_UPDATE] (state, obj) {
    if (state.assets_library[obj.assetId] && state.assets_library[obj.assetId].nodeConnectors && state.assets_library[obj.assetId].nodeConnectors[obj.connectionId]) {
      Vue.set(state.assets_library[obj.assetId].nodeConnectors[obj.connectionId], obj.key, obj.value)
    }
  },

  [types.ASSET_NODE_CONNECTOR_REMOVE] (state, obj) {
    var nodeConnectors = obj.asset.nodeConnectors
    if (nodeConnectors === undefined) {
      return
    } else {
      var id = [obj.connector.node0, obj.connector.node1].sort() + ''
      Vue.delete(nodeConnectors, id)
    }
  },

  [types.ASSET_NODE_CONNECTOR_CLEAN] (state, assetId) {
    if (state.assets_library[assetId].nodeConnectors) {
      var nodeIds = Object.keys(state.assets_library[assetId].nodes)
      var nodeConnectorKeys = Object.keys(state.assets_library[assetId].nodeConnectors)
      for (var i = 0; i < nodeConnectorKeys.length; i++) {
        var ncKey = nodeConnectorKeys[i]
        var ids = ncKey.split(',')
        if (ncKey.indexOf('|') > 0) {
          // at one point I used pipe instead of comma - this can be removed entirely eventually
          var tempId = ncKey.split('|')
          var newkey = tempId.sort().join(',')
          // console.log(ncKey.indexOf('|'), ncKey, tempId, newkey)
          Vue.set(state.assets_library[assetId].nodeConnectors, newkey, state.assets_library[assetId].nodeConnectors[ncKey])
        }

        if (nodeIds.indexOf(ids[0]) < 0 || nodeIds.indexOf(ids[1]) < 0) {
          // remove connection
          Vue.delete(state.assets_library[assetId].nodeConnectors, ncKey)
        }
      }
    }
  },
  [types.OPERATION_LIST_ADD] (state, operation) {
    Vue.set(state.operation_list, state.operation_list.length, operation)
  },
  [types.OPERATION_LIST_REMOVE] (state, operation) {
    let lastIndex = state.operation_list.length - 1
    Vue.delete(state.operation_list, lastIndex)
  },
  [types.REDOOPERATION_LIST_ADD] (state, operation) {
    Vue.set(state.redooperation_list, state.redooperation_list.length, operation)
  },
  [types.REDOOPERATION_LIST_REMOVE] (state, operation) {
    let lastIndex = state.redooperation_list.length - 1
    Vue.delete(state.redooperation_list, lastIndex)
  }
}

const actions = {
  loadState: ({ commit }) => {
    commit(types.STATE_LOAD)
  },

  createNewProject: ({ commit }) => {
    commit(types.STATE_NEW)
  },

  saveState: ({ commit }) => {
    commit(types.STATE_SAVE)
  },

  updateProjectName: ({ commit }, newName) => {
    if (newName) {
      commit(types.PROJECT_NAME_SET, newName)
    }
    commit(types.STATE_SAVE)
  },

  addAssetToLibrary: ({ commit }, asset) => {
    if (asset) {
      commit(types.ASSET_LIBRARY_ADD, asset)
    }
    commit(types.STATE_SAVE)
  },

  addPendingFile: ({ commit }, asset) => {
    if (asset) {
      commit(types.PENDING_FILE_ADD, asset)
    }
  },

  addOperation: ({ commit }, operation) => {
    if (operation) {
      commit(types.OPERATION_LIST_ADD, operation)
    }
  },
  removeOperation: ({ commit }, operation) => {
    if (operation) {
      commit(types.OPERATION_LIST_REMOVE, operation)
    }
  },
  addRedoOperation: ({ commit }, operation) => {
    if (operation) {
      commit(types.REDOOPERATION_LIST_ADD, operation)
    }
  },
  removeRedoOperation: ({ commit }, operation) => {
    if (operation) {
      commit(types.REDOOPERATION_LIST_REMOVE, operation)
    }
  },
  removePendingFile: ({ commit }, asset) => {
    if (asset) {
      commit(types.PENDING_FILE_REMOVE, asset)
    } else {
      console.error('missing asset')
    }
  },

  loadProjectFile: ({ commit }, projectFile) => {
    // create reader object
    var reader = new window.FileReader()
    // setupe data read handler
    reader.onload = function (e) {
      // get file content and update data
      var data = JSON.parse(e.target.result)
      commit(types.STATE_LOAD, data)
      commit(types.STATE_SAVE)
    }
    // read file
    reader.readAsText(projectFile, 'UTF-8')
  },

  loadPendingFiles: ({ commit, state }) => {
    Object.keys(state.upload_files_pending).map(function (pendingFileKey) {
      var pendingFile = state.upload_files_pending[pendingFileKey]
      var reader = new window.FileReader()
      reader.onload = function (e) {
        // update data on pending file
        commit(types.PENDING_FILE_UPDATE, {pendingFile: pendingFile, key: 'svgString', value: e.target.result})

        // move to assets
        commit(types.ASSET_LIBRARY_ADD, pendingFile)

        // set file as loaded
        commit(types.PENDING_FILE_UPDATE, {pendingFile: pendingFile, key: 'loaded', value: true})

        // remove from pending files
        commit(types.PENDING_FILE_REMOVE, pendingFile)

        // save change
        commit(types.STATE_SAVE)
      }
      reader.readAsText(pendingFile.file, 'UTF-8')
    })
  },

  updatePendingFile: ({ commit }, obj) => {
    if (obj.pendingFile && obj.key && obj.value) {
      return commit(types.PENDING_FILE_UPDATE, obj)
    } else {
      console.error('missing `pendingFile`, `key`, or `value` property')
    }
  },

  addNodeToAsset: ({ commit }, obj) => {
    if (obj.assetId && obj.node) {
      commit(types.ASSET_NODE_ADD, obj)
      commit(types.STATE_SAVE)
      // commit(types.OPERATION_LIST_ADD, { assetId: obj.assetId, node: obj.node, action: 'ADD_NODE' })
    } else {
      console.error('missing property')
    }
  },

  updateAssetNode: ({ commit }, obj) => {
    if (obj.nodeId && obj.assetId && obj.key && obj.value !== undefined) {
      commit(types.ASSET_NODE_UPDATE, obj)
      commit(types.STATE_SAVE)
    } else {
      console.error('missing property')
    }
  },

  updateAssetPerspectiveDistortion: ({ commit }, obj) => {
    if (obj.assetId && obj.value !== undefined) {
      commit(types.ASSET_PERSPECTIVEDISTORTION_UPDATE, obj)
      commit(types.STATE_SAVE)
    } else {
      console.error('missing property assetId or value')
    }
  },

  removeAssetNodeField: ({ commit }, obj) => {
    if (obj.nodeId && obj.assetId && obj.key) {
      commit(types.ASSET_NODE_REMOVE_FIELD, obj)
      commit(types.STATE_SAVE)
    } else {
      console.error('missing property')
    }
  },

  removeAssetConnectionField: ({ commit }, obj) => {
    if (obj.connectionId && obj.assetId && obj.key) {
      commit(types.ASSET_NODE_CONNECTOR_REMOVE_FIELD, obj)
      commit(types.STATE_SAVE)
    } else {
      console.error('missing property')
    }
  },

  updateAssetConnection: ({ commit }, obj) => {
    if (obj.assetId && obj.connectionId && obj.key && obj.value !== undefined) {
      commit(types.ASSET_NODE_CONNECTOR_UPDATE, obj)
      commit(types.STATE_SAVE)
    } else {
      console.error('missing property')
    }
  },

  roundNodes: ({ commit }, obj) => {
    if (obj.assetId && obj.dec !== undefined) {
      commit(types.ASSET_NODE_ROUND, obj)
      commit(types.STATE_SAVE)
    } else {
      console.error('missing property assetId')
    }
  },

  removeNode: ({ commit }, obj) => {
    if (obj.nodeId && obj.assetId) {
      commit(types.ASSET_NODE_REMOVE, obj)
      commit(types.STATE_SAVE)
    } else {
      console.error('missing property')
    }
  },

  addNodeConnectorToAsset: ({ commit }, obj) => {
    if (obj.asset && obj.connector) {
      commit(types.ASSET_NODE_CONNECTOR_ADD, obj)
      commit(types.STATE_SAVE)
    }
  },

  removeNodeConnector: ({ commit }, obj) => {
    if (obj.asset && obj.connector) {
      commit(types.ASSET_NODE_CONNECTOR_REMOVE, obj)
      commit(types.STATE_SAVE)
    }
  },

  cleanupAssetConnections: ({ commit }, assetId) => {
    commit(types.ASSET_NODE_CONNECTOR_CLEAN, assetId)
    commit(types.STATE_SAVE)
  }

}

const getters = {
  assetUniqueNames: state => {
    var names = []
    for (var key in state.assets_library) {
      var asset = state.assets_library[key]
      names.push(asset.unique_name)
    }
    return names
  },
  assetList: state => {
    return state.assets_library
  },
  pendingUploadFiles: state => {
    return state.upload_files_pending
  },
  validFileTypes: state => {
    return state.valid_file_types
  },
  uploadWarnings: state => {
    return state.upload_warnings
  },
  operationList: state => {
    return state.operation_list
  },
  redoOperationList: state => {
    return state.redooperation_list
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/project.js